import React from 'react'
import LayoutComp from '../../layout/LayoutComp'
import StakeRacesBlog from '../../components/promotions/viewall/promotion/Blog/StakeRacesBlog'

const StakeRaces = () => {
    return (
        <>
            <LayoutComp>
                <StakeRacesBlog />
            </LayoutComp>
        </>
    )
}

export default StakeRaces